import React from 'react';
import { Bar } from 'react-chartjs-2';

interface totalUnitsSoldBarProps {
  isExpanded?: boolean;
}

export const TotalUnitsSoldBar = ({ data, isExpanded = false }) => {
  const chartData = {
    labels: Object.keys(data),
    datasets: [{
      label: 'Sales',
      data: Object.values(data),
      backgroundColor: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#4BC0C0',
      ],
      borderColor: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#4BC0C0',
      ],
      borderWidth: 1,
      barThickness: 20,
    }]
  };

  const chartOptions = {
    indexAxis: 'y' as const,
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          color: 'rgba(255, 255, 255, 0.05)',  
        },
        ticks: {
          color: 'white'
        },
      },
      y: {
        grid: {
          color: 'rgba(255, 255, 255, 0.05)',  
        },
        ticks: {
          color: 'white'
        }
      }
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
  };

  const cardStyle: React.CSSProperties = {
    background: 'rgb(26,35,63)',
    border: '5px solid rgb(96,102,220)',
    borderRadius: isExpanded ? '0 0 8px 8px' : '8px',
    color: 'white',
    margin: '0',
    padding: '1rem 1rem 0 1rem',
    height: '100%',
    boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
  };

  const barContainerStyle: React.CSSProperties = {
    position: 'relative',
    height: '200px',
    width: '100%'
  };

  return (
    <div style={cardStyle}>
      <div style={barContainerStyle}>
        <Bar data={chartData} options={chartOptions}/>
      </div>
    </div>
  );
};